/* tslint:disable */
/* eslint-disable */
/**
 * MINDD Survey API Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Agreement } from '../model';
// @ts-ignore
import type { CreateRequest } from '../model';
// @ts-ignore
import type { ServiceType } from '../model';
/**
 * AgreementControllerApi - axios parameter creator
 * @export
 */
export const AgreementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<ServiceType>} agreements 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgreement: async (agreements: Array<ServiceType>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreements' is not null or undefined
            assertParamExists('createAgreement', 'agreements', agreements)
            const localVarPath = `/api/v1/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (agreements) {
                localVarQueryParameter['agreements'] = agreements;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (subjectMetaId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjectMetaId' is not null or undefined
            assertParamExists('get', 'subjectMetaId', subjectMetaId)
            const localVarPath = `/api/v1/agreements/{subjectMetaId}`
                .replace(`{${"subjectMetaId"}}`, encodeURIComponent(String(subjectMetaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrl: async (subjectMetaId: string, createRequest: CreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjectMetaId' is not null or undefined
            assertParamExists('getUrl', 'subjectMetaId', subjectMetaId)
            // verify required parameter 'createRequest' is not null or undefined
            assertParamExists('getUrl', 'createRequest', createRequest)
            const localVarPath = `/api/v1/agreements/{subjectMetaId}/url`
                .replace(`{${"subjectMetaId"}}`, encodeURIComponent(String(subjectMetaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send: async (subjectMetaId: string, createRequest: CreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subjectMetaId' is not null or undefined
            assertParamExists('send', 'subjectMetaId', subjectMetaId)
            // verify required parameter 'createRequest' is not null or undefined
            assertParamExists('send', 'createRequest', createRequest)
            const localVarPath = `/api/v1/agreements/{subjectMetaId}/send`
                .replace(`{${"subjectMetaId"}}`, encodeURIComponent(String(subjectMetaId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication authBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementControllerApi - functional programming interface
 * @export
 */
export const AgreementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<ServiceType>} agreements 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAgreement(agreements: Array<ServiceType>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAgreement(agreements, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.createAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(subjectMetaId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(subjectMetaId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUrl(subjectMetaId: string, createRequest: CreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUrl(subjectMetaId, createRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.getUrl']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async send(subjectMetaId: string, createRequest: CreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.send(subjectMetaId, createRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementControllerApi.send']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgreementControllerApi - factory interface
 * @export
 */
export const AgreementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<ServiceType>} agreements 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAgreement(agreements: Array<ServiceType>, options?: any): AxiosPromise<Array<Agreement>> {
            return localVarFp.createAgreement(agreements, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(subjectMetaId: string, options?: any): AxiosPromise<Array<Agreement>> {
            return localVarFp.get(subjectMetaId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUrl(subjectMetaId: string, createRequest: CreateRequest, options?: any): AxiosPromise<string> {
            return localVarFp.getUrl(subjectMetaId, createRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subjectMetaId 
         * @param {CreateRequest} createRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        send(subjectMetaId: string, createRequest: CreateRequest, options?: any): AxiosPromise<string> {
            return localVarFp.send(subjectMetaId, createRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgreementControllerApi - object-oriented interface
 * @export
 * @class AgreementControllerApi
 * @extends {BaseAPI}
 */
export class AgreementControllerApi extends BaseAPI {
    /**
     * 
     * @param {Array<ServiceType>} agreements 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public createAgreement(agreements: Array<ServiceType>, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).createAgreement(agreements, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subjectMetaId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public get(subjectMetaId: string, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).get(subjectMetaId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subjectMetaId 
     * @param {CreateRequest} createRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public getUrl(subjectMetaId: string, createRequest: CreateRequest, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).getUrl(subjectMetaId, createRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subjectMetaId 
     * @param {CreateRequest} createRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementControllerApi
     */
    public send(subjectMetaId: string, createRequest: CreateRequest, options?: RawAxiosRequestConfig) {
        return AgreementControllerApiFp(this.configuration).send(subjectMetaId, createRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

